import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BambaSharedModule} from '../../shared/bamba-shared.module';
import {ShopComponent} from '../../components/index-pagina';
import {Ng5SliderModule} from 'ng5-slider';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ReactiveFormsModule} from '@angular/forms';

const routes: Routes = [
  {
    path: '',
    component: ShopComponent
  }
];

@NgModule({
  declarations: [ShopComponent],
  imports: [
    BambaSharedModule,
    Ng5SliderModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
  ]
})
export class ShopModule {
}
